export const filtering = {
    0: "common.all",
    1: "common.only-my-printers",
    2: "common.shared-with-me"
}